<template>
  <div class="body">
    客户详情

    <div class="customInfo">
      <div>
        头像
      </div>
      <div>
        基本信息
      </div>
    </div>


    <div class="inv-h-w">
      <div :class="['inv-h',Inv==1?'inv-h-se':'']" @click="Inv=1">信息审核</div>
      <div :class="['inv-h',Inv==2?'inv-h-se':'']" @click="Inv=2">其他</div>
      <div :class="['inv-h',Inv==3?'inv-h-se':'']" @click="Inv=3">其他</div>
      <div :class="['inv-h',Inv==4?'inv-h-se':'']" @click="Inv=4">其他</div>
    </div>


    <div class="bodyInv" v-show="Inv == 1">

      <div class="bodyList">

        <div class="table">
          <el-table :data="customList" style="width: 100%">
            <el-table-column prop="entryDt" label="时间" width="180"></el-table-column>
            <el-table-column prop="exceptionName" label="修改项目" width="180"></el-table-column>
            <el-table-column prop="oldValue" label="修改前"></el-table-column>
            <el-table-column prop="newValue" label="修改后"></el-table-column>
            <el-table-column prop="status" :formatter="statusType" label="状态"></el-table-column>
            <el-table-column prop="datumStatus" label="操作">
              <template slot-scope="scope">
                <img class="imgOpera" @click="updateStatus(scope.row,3)"
                     src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/summer/pass.png">
                <img class="imgOpera" @click="updateStatus(scope.row,2)"
                     src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/summer/reject.png">
              </template>
            </el-table-column>
          </el-table>

          <el-dialog title="备注" :visible.sync="dialogVisible" width="30%">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="excption.remark"></el-input>
            <span slot="footer" class="dialog-footer">
                            <el-button @click="dialogVisible = false">取 消</el-button>
                            <el-button type="primary" @click="falseStatus">确 定</el-button>
                        </span>
          </el-dialog>
        </div>

        <div class="addException">
          <div class="exception">
            <p>请选择异常项目</p>
            <div v-for="(item,index) in exceptions" :key="index">
              <el-checkbox v-model="item.possess">{{ item.exceptionName }}</el-checkbox>
              <el-input class="textException" v-model="item.remark" type="textarea" :rows="2"
                        placeholder="请输入内容"></el-input>
            </div>
            <p class="exceptionButton">
              <span>  <el-button plain type="primary">取消</el-button></span>
              <span>  <el-button type="primary" @click="addException">确定</el-button></span>
            </p>
          </div>
        </div>

      </div>


    </div>

  </div>
</template>


<script>
export default {
  data() {
    return {
      Inv: 1,
      exceptions: [],
      customList: [],
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }],
      excption: {
        id: null,
        status: null,
        remark: null,
      },
      dialogVisible: false
    }
  },
  created() {
    //监听游览器后退事件
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.goBack, false)
    }
  },
  destroyed() {
    window.removeEventListener('popstate', this.goBack, false)
  },
  mounted() {
    this.exceptionList()
    this.customExceptionList()
  },
  methods: {

    //后退事件
    goBack(){
      this.$router.replace({path:'customer'})
    },

    exceptionList() {
      this.joker.customer.getExceptionList(this.$route.query.customId).then(res => {
        this.exceptions = res.content
      })
    },

    customExceptionList() {
      this.joker.customer.customException(this.$route.query.customId).then(res => {
        this.customList = res.content
      })
    },

    addException() {
      var data = {customerId: this.$route.query.customId, exceptions: this.exceptions}
      this.joker.customer.addException(data).then(res => {
        if (res.success) {
          alert('添加成功')
        }
      })
    },
    //修改状态
    updateStatus(row, type) {
      this.excption.id = row.id
      this.excption.status = type
      if (type == 2) {
        this.dialogVisible = true
      } else {
        this.joker.customer.upStatus(this.excption).then(res => {
          if (res.success) {
            this.excption.id = null
            this.excption.status = null
            this.excption.remark = null
          }
          this.customExceptionList()
        })
      }
    },
    //确认拒绝
    falseStatus() {
      if (this.excption.remark != null) {
        this.joker.customer.upStatus(this.excption).then(res => {
          this.excption.id = null
          this.excption.status = null
          this.excption.remark = null
        })
      }
    },
    //状态
    statusType(row, column) {
      switch (row.status) {
        case 0:
          return '未修改'
          break;
        case 1:
          return '已修改'
          break;
        case 2:
          return '已拒绝'
          break;
        case 3:
          return '已通过'
          break;
      }
    },
  }
}
</script>


<style scoped>
.customInfo {
  background-color: #ffffff;

}

.inv-h-w {
  background-color: #FFFFFF;
  display: flex;
  margin-top: 1%;
  width: 96%;
  border-radius: 10px;
  margin-left: 2%;
  margin-bottom: 1%;
  height: 40px;
  font-size: 18px;
}

.inv-h {

  /* flex: 1; */
  text-align: center;
  color: #6d6f78;
  line-height: 40px;
  display: inline-block;
  width: 15%;
}

.inv-h-se {
  border-radius: 10px;
  color: #FFFFFF;
  background-color: #5BA7FF;
  border-bottom: 4 upx solid #5BA7FF;
}

.bodyInv {
  background-color: #FFFFFF;
  width: 96%;
  margin-left: 2%;
  border-radius: 10px;
}

.table {
  width: 70%;
  /* margin: 0 auto; */
}

.addException {
  width: 20%;
  margin-top: 2%;
  margin-bottom: 2%;
  height: 90%;
  border: 1px solid #EBEEF5;
  border-radius: 15px;
}

.bodyList {
  display: flex;
  justify-content: space-around;
}

.exceptionButton {
  display: flex;
  justify-content: space-around;
  margin-top: 5%;
}

.imgOpera {
  width: 20px;
  height: 20px;
  margin-left: 5px;
}


</style>



// WEBPACK FOOTER //
// src/components/Customer/customerInfo.vue